import { routes } from "../../../../configs/configNavLink";

const Routes = [
  // {
  //   header: "Vesting",
  //   link: routes.vesting,
  //   id: "vesting",
  // },
];
export default Routes;
